/**
 * Bank Statement Download Arche Page
 *
 * Route wrapper: ArcheLayout + Routes for the bank-statement-download arche.
 */

import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { BankStatementDownloadPage } from './BankStatementDownloadPage';

export function BankStatementDownloadArchePage() {
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/*" element={<BankStatementDownloadPage />} />
      </Routes>
    </ArcheLayout>
  );
}
